<template>
  <button v-bind:class="[type, colorTheme]" @mousedown="startRipple($event)" @mouseup="initializeRipple()" @mouseleave="hideRipple()">{{title}}
    <div class="ripple-container">
      <div class="ripple"></div>
    </div>
  </button>
</template>

<script>
  export default {
    name: 'Button',
    props: ['title', 'type', 'colorTheme'],
    methods: {
      startRipple(event) {
        const rippleWidthAndHeight = this.distanceFromFarSide(event) * 2.25
        this.$el.querySelector('.ripple').style.cssText = `
          left: ${event.offsetX - (rippleWidthAndHeight / 2)}px;
          top: ${event.offsetY - (rippleWidthAndHeight / 2)}px;
          width: ${rippleWidthAndHeight}px;
          height: ${rippleWidthAndHeight}px;
          opacity: 1;
          transition-duration: 500ms;
          transform: scale(1);
        `
      },
      distanceFromFarSide(element) {
        const elementMiddle = element.target.offsetWidth / 2
        return (element.offsetX > elementMiddle) ? element.offsetX : (element.target.offsetWidth - element.offsetX)
      },
      initializeRipple() {
        this.hideRipple()
        this.$emit('button-click')
      },
      hideRipple() {
        let rippleElement = this.$el.querySelector('.ripple')
        rippleElement.style.cssText = `opacity: 0; transform: scale(0);`
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';

button {
  @include button();

  &.primary {
    background: $gd-blue;
    color: $gd-white;

    .ripple {
      background: $gd-white-bg-hover;
    }
  }

  &.secondary {
    background: $gd-white;

    .ripple {
      background: $primary-shadow;
    }
  }

  &.warning {
    background: $gd-red;
    color: $gd-white;

    .ripple {
      background: $gd-red-bg-hover;
    }
  }

  &.flat {
    background: transparent;
    color: $gd-red;
    @include default-shadow(0);

    &:hover {
      background: $gd-red-bg;
    }
  }

  &.outlined {
    background: transparent;
    font-size: 13px;
    color: $gd-dark-gray;
    border: 1px dashed $primary-shadow;
    @include default-shadow(0);

    &:hover {
      @include default-shadow(0);
    }
  }
}

.ripple-container {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  pointer-events: none;
  overflow: hidden;

  .ripple {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
    opacity: 0;
    transition: opacity, -webkit-transform 0s cubic-bezier(0, 0, .2 ,1);
    transition: opacity, transform 0s cubic-bezier(0, 0, .2, 1);
    transition: opacity, transform 0s cubic-bezier(0, 0, .2, 1), -webkit-transform 0s cubic-bezier(0, 0, .2, 1);
    -webkit-transform: scale(0);
    transform: scale(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form-elements/Button.vue